import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { ReactComponent as User } from '../../../assets/images/scouts/user.svg'
import { ReactComponent as Settings } from '../../../assets/images/scouts/setting.svg'
import { ReactComponent as LogOut } from '../../../assets/images/scouts/logout.svg'
import './ProfileToggle.scss'
import { Avatar } from 'antd'
import { fetchStartupUserLogout } from '../../../redux/auth/authActions'

const ProfileToggle = props => {
  const dispatch = useDispatch()
  const { profile_data } = useSelector(state => state.trackingFlowControlReducer)
  const [activeProfile, setActiveProfile] = useState(false)
  const [activeCompanyInfo, setActiveCompanyInfo] = useState(false)

  // Handles the click event for toggling the profile section visibility.
  const handleProfileClick = () => {
    setActiveProfile(!activeProfile)
  }

  // Handles the click event for toggling the company information section visibility and navigates to the company profile page.
  const handleCompanyInfoClick = () => {
    setActiveCompanyInfo(!activeCompanyInfo)
    props.history.push('/tracking/profile/company')
  }

  // Handles the click event for toggling the company information section visibility and navigates to the email notification settings page.
  const handleProfileSettingClick = () => {
    setActiveCompanyInfo(!activeCompanyInfo)
    props.history.push('/tracking/setting/EmailNotification')
  }

  // Handles the click event for logging out the user by clearing local storage and redirecting to the home page.
  const handleLogout = async () => {
    props.setLogoutLoader(true)
    const success = await dispatch(fetchStartupUserLogout())
    if (success) {
      localStorage.removeItem('startup_token')
      props.setLogoutLoader(false)
      props.history.replace('/startup/login')
    } else {
      props.setLogoutLoader(false)
    }
  }

  return (
    <div className="custom-dropdown-PT">
      <Dropdown isOpen={activeProfile} toggle={handleProfileClick}>
        <DropdownToggle>
          <Avatar className="avatar-wrap" src={profile_data?.data?.logo}>
            {profile_data?.data?.company_name?.charAt(0).toUpperCase()}
          </Avatar>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={handleCompanyInfoClick}>
            <User className="mr-3" />
            Profile
          </DropdownItem>
          <DropdownItem onClick={handleProfileSettingClick}>
            <Settings className="mr-3" />
            Settings
          </DropdownItem>
          <DropdownItem onClick={handleLogout}>
            <LogOut className="mr-3" />
            Logout
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  )
}

export default withRouter(ProfileToggle)
